import {Language} from '../umpire-language-service';
import {UmpireOttEvent} from '../umpire-ott-event';
import {UmpireOttFormat} from '../umpire-ott-format';

export interface UmpireOttSegment {
  id: string;
  name: string;
  events_count: number;
  type: string;
  format: Partial<UmpireOttFormat>;
  events?: UmpireOttEvent[];
  locale: Language;
  available_translations: Language[];
}
